import { formatRelativeShort } from "../../services/stringServices";
import { deadlineStatusEnum, taskStatusEnum } from "../../services/EnumsService";
import { projectStatusEnum } from "../../services/EnumsService";
import { useNavigate } from "react-router-dom";

export default function ExpandableProjectComponent({project, categoryId}) {
    const navigate = useNavigate();
    
    const handleClick = () => {
        navigate(`/category-projects/${categoryId}?projectId=${project.id}`);
    };
    
    return (
        <div 
            className="flex flex-col rounded-lg p-2 m-2 text-lg border-solid border-2 border-gray-300 bg-white cursor-pointer hover:shadow-lg hover:border-blue-400 transition-all"
            onClick={handleClick}
        >
            <div className="flex flex-row ">
                <div className="px-2 rounded-md" style={{ backgroundColor: `${projectStatusEnum(project.status).color}`}}>
                    {project.name}
                </div>
                <div className="font-bold text-right ml-2" style={{ color: `${deadlineStatusEnum(project.deadlineStatus).color}`}}>
                    {formatRelativeShort(project.deadline)}
                </div>
            </div>
            <div>
                {project.tasks.length >= 0 && (
                    <div className="flex flex-row gap-1 mt-1 text-gray-500 ml-2 italic">
                        <div className="mt-2">
                            {project.tasks.length} {project.tasks.length === 1 ? 'tarea:' : 'tareas:'}
                        </div>                        
                        <div className="flex flex-row gap-1 mt-2">
                            <div className="px-1 rounded-md" title="No iniciadas" style={{ color: `${taskStatusEnum(0).textColor}`}}>
                                {project.notStartedTasksCount}
                            </div>
                            <div className="px-1 rounded-md" title="Completadas" style={{ color: `${taskStatusEnum(2).textColor}`}}>                        
                                {project.completedTasksCount}
                            </div>
                            <div className="px-1 rounded-md" title="En progreso" style={{ color: `${taskStatusEnum(1).textColor}`}}>                        
                                {project.inProgressTasksCount}
                            </div>
                            <div className="px-1 rounded-md" title="Canceladas" style={{ color: `${taskStatusEnum(3).textColor}`}}>
                                {project.cancelledTasksCount}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div>
                {project.resources != null && project.resources.length >= 0 && (
                    <div className="ml-2 text-gray-500 italic">
                        {project.resources.length} {project.resources.length === 1 ? 'recurso' : 'recursos'}
                    </div>
                )}
            </div>

        </div>
        )
}